import React from "react";
import styled, { keyframes } from "styled-components";
import BasicButton from "../BasicButton/BasicButton";
import { GAME_STATES } from "../../CoreLoop";
import ZuckPlus from "../ZuckPlus/ZuckPlus";

const ResultsWrapper = styled.div`
  padding: 24px 36px;
  max-width: min(800px, 90vw);
  max-height: min(800px, 90vh);
  max-width: min(800px, 90dvw);
  max-height: min(800px, 90dvh);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  opacity: var(--opacity);
  pointer-events: var(--pointer-events);
  transition: opacity 0.25s ease-in-out;
  grid-area: overlap;
  margin: 0 auto;
`;

const ResultsImage = styled.img`
  object-fit: contain;
  border-radius: 8px;
  width: 100%;
  height: auto;
  max-width: min(800px, 70vw);
  max-height: min(800px, 60vh);
  max-width: min(700px, 70dvw);
  max-height: min(600px, 60dvh);
`;

const ResultsButton = styled(BasicButton)`
  font-size: 1.25rem;
  padding: 8px 8px;
  position: relative;
`;

const ButtonHolder = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
`;

const DownloadAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(-50%);
  }
  20% {
    opacity: 0.8;
  }
  60% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-150%);
  }
`;

const DownloadMessage = styled.p`
  font-size: 1rem;
  padding: 8px 8px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  color: var(--color-indigo-900);
  animation: ${DownloadAnimation} 1s ease-in-out both;
  background-color: var(--color-amber-100);
  border-radius: 8px;
`;

function Results({
  gameState,
  results,
  coreLoop,
  hasPurchasedZuckPlus,
  setHasPurchasedZuckPlus,
}) {
  let opacity = 0;
  let pointerEvents = "none";
  if (gameState === GAME_STATES.SHOWING_RESULTS) {
    opacity = 1;
    pointerEvents = "auto";
  }

  const [showDownloadMessage, setShowDownloadMessage] = React.useState(false);

  const handleShareClick = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = results.comparisonImage;
    downloadLink.download = "myzuck.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    setShowDownloadMessage(true);
    setTimeout(() => {
      setShowDownloadMessage(false);
    }, 1500);
  };

  return (
    <ResultsWrapper
      style={{ "--opacity": opacity, "--pointer-events": pointerEvents }}
    >
      {gameState === GAME_STATES.SHOWING_RESULTS && (
        <>
          <a href={results.comparisonImage} download="myzuck.png">
            <ResultsImage src={results.comparisonImage} />
          </a>
        </>
      )}
      <ButtonHolder>
        <ZuckPlus
          hasPurchasedZuckPlus={hasPurchasedZuckPlus}
          setHasPurchasedZuckPlus={setHasPurchasedZuckPlus}
        />
        <ResultsButton onClick={handleShareClick}>
          share
          {showDownloadMessage && (
            <DownloadMessage>Downloaded!</DownloadMessage>
          )}
        </ResultsButton>
        <ResultsButton onClick={() => coreLoop.current.runNewGame()}>
          play again
        </ResultsButton>
      </ButtonHolder>
    </ResultsWrapper>
  );
}

export default Results;
